/* ============================================================
   La Nani — căutare în formularul EasySell: județ și localitate

   Problema: în formularul lor, județul e un <select> cu 42 de opțiuni
   prin care omul derulează, iar localitatea se scrie de mână, fără niciun
   ajutor. Pe telefon, la 60-70 de ani, acolo se pierd comenzi.

   Ce face fișierul ăsta:
     - peste <select name="province"> pune un câmp în care scrii, iar lista
       se filtrează: întâi județele care ÎNCEP cu ce ai scris, apoi cele
       care CONȚIN literele alea;
     - la <input name="city">, după ce s-a ales județul, descarcă lista
       localităților DOAR din județul ăla (1-5 KB) și o filtrează la fel.

   Reguli pe care le respectă, ca să nu strice comanda:

   1. Selectul rămâne în pagină și rămâne sursa adevărului. Câmpul nostru
      doar îi scrie valoarea și trimite `change` + `input`, ca EasySell să
      vadă exact ce vede și când omul alege cu degetul.

   2. `required` se mută de pe select pe câmpul nostru. Un câmp obligatoriu
      ascuns nu poate primi focus, iar browserul refuză trimiterea cu
      „An invalid form control is not focusable" — formular mort, fără
      niciun mesaj. Mutarea se întâmplă doar dacă scriptul chiar rulează;
      dacă nu se încarcă, selectul rămâne cu `required` și cu aspectul lui
      normal, iar formularul merge ca înainte.

   3. Localitatea NU e obligatorie din listă. Omul poate scrie orice, chiar
      dacă nu e în listă — satele mici lipsesc din orice bază de date, iar
      un câmp care refuză ce scrie omul e mai rău decât unul fără ajutor.
      Lista e sugestie, nu gardian.

   4. Diacriticele nu contează. „arges" găsește „Argeș", „bucuresti"
      găsește „București". Nimeni nu scrie cu diacritice pe telefon.

   Datele: assets/ln-loc-XX.json, câte un fișier pe județ, din baza SIRUTA
   (13.251 de localități). Codurile lor de județ sunt „RO_AB", ale noastre
   „AB" — se taie prefixul.
   ============================================================ */
(function () {
  'use strict';

  var CATE_ARAT = 60;          /* câte rezultate desenăm; mai multe n-are cine citi */
  var listaLocalitati = null;  /* cache: { cod: [nume, ...] } */
  var cereriInCurs = {};
  /* Județul ales ACUM. Lista descărcată se folosește doar dacă e a lui.
     Fără asta, cine trece de la București la Bistrița-Năsăud vede în
     continuare sectoarele: lista veche rămâne în memorie până sosește cea
     nouă, iar omul apucă să atingă câmpul între timp. Se vedea pe live. */
  var codCurent = null;
  var reDeseneazaOrasul = null;

  /* ---------- text fără diacritice, litere mici ---------- */
  function simplu(s) {
    s = (s || '').toString().toLowerCase();
    /* normalize() lipsește pe browsere foarte vechi; atunci înlocuim de mână */
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s
      .replace(/[ăâ]/g, 'a').replace(/[îi]/g, 'i')
      .replace(/[șş]/g, 's').replace(/[țţ]/g, 't')
      .replace(/\s+/g, ' ').trim();
  }

  /* Întâi ce începe cu textul, apoi ce îl conține. Exact ordinea cerută. */
  function filtreaza(toate, text) {
    var q = simplu(text);
    if (!q) return toate.slice(0, CATE_ARAT);
    var incep = [], contin = [];
    for (var i = 0; i < toate.length; i++) {
      var v = simplu(toate[i]);
      if (v.indexOf(q) === 0) incep.push(toate[i]);
      else if (v.indexOf(q) > 0) contin.push(toate[i]);
      if (incep.length + contin.length >= CATE_ARAT * 2) break;
    }
    return incep.concat(contin).slice(0, CATE_ARAT);
  }

  /* ---------- cutia cu sugestii ----------

     Cutia se agață de <body>, NU lângă câmp.

     Prima variantă o punea ca vecin al câmpului, deci înăuntrul
     formularului lor. Acolo se amesteca cu rândurile lor: bordura câmpului
     de Localitate, care vine imediat dedesubt, se desena peste listă și
     apărea ca o linie în plus între primul și al doilea județ. Nicio
     valoare de `z-index` n-a rezolvat-o, pentru că elementele lor stau în
     același strat cu ea.

     Stă ca ULTIM copil al ferestrei lor, nu lângă câmp. Două motive:

     1. Fără vecini, nicio bordură a formularului nu se mai amestecă cu ea.
        Bordura câmpului de Localitate, care vine imediat sub județ, apărea
        ca o linie în plus între primul și al doilea județ.

     2. Fereastra lor are `z-index: 2147483647`, adică maximul pe care îl
        acceptă un browser. Nu există valoare mai mare. O casetă pusă la
        nivelul paginii rămâne DESENATĂ DEDESUBT oricât de sus o ridici —
        măsurat: există, e vizibilă, are coordonatele bune, și tot nu se
        vede. Înăuntrul ferestrei, fiind ultimul copil, se desenează peste
        tot ce e în ea.

     Poziția rămâne `fixed`, în coordonatele ecranului, deci nu contează
     unde stă în arbore. */
  var cutii = [];

  /* Gazda casetei e cutia din jurul câmpului, nu fereastra.

     Înainte caseta stătea direct în `.es-modal`, cu `position:fixed`, iar
     poziția i-o calcula JavaScript-ul din coordonatele ecranului. Pe telefon
     asta se rupe: când se deschide tastatura, ecranul vizibil se micșorează
     și se mută sub tine, iar caseta rămâne unde era, adică fix peste câmpul
     în care tocmai scrii. Nu mai vezi ce tastezi.

     Acum caseta e copilul cutiei care ține câmpul, cu `position:absolute`.
     Poziția ei nu mai depinde de ecran: e agățată de câmp și se mișcă odată
     cu el, orice ar face tastatura. */
  function gazdaCutiei(camp) {
    var g = camp.closest('.ln-cauta');
    if (g) return g;
    g = camp.parentElement || document.body;
    g.classList.add('ln-cauta__gazda');   /* doar `position:relative` */
    return g;
  }

  function faceCutie(camp) {
    var c = document.createElement('div');
    c.className = 'ln-cauta__lista';
    c.setAttribute('role', 'listbox');
    c.hidden = true;
    gazdaCutiei(camp).appendChild(c);
    return c;
  }

  /* Cât loc a mai rămas sub câmp, măsurat în ce se vede cu adevărat.

     `window.innerHeight` nu scade când urcă tastatura pe iPhone, deci după
     el caseta ieșea sub taste. `visualViewport` e singurul care știe cât a
     mai rămas. Marginea de jos a ferestrei lor o taie și ea: fereastra are
     `overflow:auto`, deci ce trece de ea se vede doar dacă omul derulează. */
  function spatiuSub(camp) {
    var vv = window.visualViewport;
    var josEcran = vv ? vv.offsetTop + vv.height : window.innerHeight;
    var fereastra = camp.closest('#easysell-modal, .es-modal');
    var jos = josEcran;
    if (fereastra) jos = Math.min(jos, fereastra.getBoundingClientRect().bottom);
    return jos - camp.getBoundingClientRect().bottom - 10;
  }

  /* Așezarea sub câmp, în coordonatele GAZDEI, nu ale ecranului.

     Cele două dreptunghiuri se citesc în aceeași clipă și se scade unul din
     altul, deci diferența rămâne aceeași oricât s-ar derula pagina sau s-ar
     muta ecranul sub tastatură. De aici vine garanția că lista stă lipită
     sub câmp și nu ajunge niciodată peste el.

     Singurul lucru care depinde de ecran e înălțimea. Dacă nu încape, se
     lasă măcar trei rânduri și restul se vede derulând: mai bine puțin
     tăiat jos decât acoperind câmpul în care omul scrie. */
  function aseaza(cutie, camp) {
    /* Fereastra lor se redeschide din zero la fiecare produs; dacă a fost
       refăcută, caseta trebuie mutată în cea nouă. */
    var g = gazdaCutiei(camp);
    if (cutie.parentElement !== g) g.appendChild(cutie);
    var rg = g.getBoundingClientRect();
    var r = camp.getBoundingClientRect();
    cutie.style.top = Math.round(r.bottom - rg.top) + 'px';
    cutie.style.left = Math.round(r.left - rg.left) + 'px';
    cutie.style.width = Math.round(r.width) + 'px';
    cutie.style.maxHeight = Math.max(132, Math.min(spatiuSub(camp), 320)) + 'px';
  }

  function urmareste(cutie, camp) {
    cutii.push({ cutie: cutie, camp: camp });
    if (urmareste.pornit) return;
    urmareste.pornit = true;
    var reasaza = function () {
      cutii.forEach(function (x) { if (!x.cutie.hidden) aseaza(x.cutie, x.camp); });
    };
    window.addEventListener('scroll', reasaza, true);   /* true: și derularea dinăuntrul ferestrei lor */
    window.addEventListener('resize', reasaza);
    /* Tastatura care urcă și coboară nu dă `resize` pe iPhone, doar aici. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', reasaza);
      window.visualViewport.addEventListener('scroll', reasaza);
    }
  }

  function deseneaza(cutie, valori, laAlegere, camp) {
    cutie.innerHTML = '';
    if (!valori.length) {
      cutie.hidden = true;
      return;
    }
    if (camp) aseaza(cutie, camp);
    valori.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ln-cauta__optiune';
      b.setAttribute('role', 'option');
      b.textContent = v;
      /* `mousedown`, nu `click`: pe telefon, atingerea scoate întâi focusul
         din câmp, iar cutia s-ar închide înainte să apuce clickul. */
      b.addEventListener('mousedown', function (ev) {
        ev.preventDefault();
        laAlegere(v);
      });
      cutie.appendChild(b);
    });
    cutie.hidden = false;
  }

  /* ---------- județul ---------- */
  function legJudetul(select) {
    if (select.dataset.lnGata) return;
    select.dataset.lnGata = '1';

    var optiuni = [];
    var dupaNume = {};
    Array.prototype.forEach.call(select.options, function (o) {
      var t = (o.text || '').trim();
      if (!o.value || !t) return;
      optiuni.push(t);
      dupaNume[t] = o.value;
    });
    if (!optiuni.length) return;

    var camp = document.createElement('input');
    camp.type = 'text';
    /* Clasele unui câmp de TEXT de-al lor, nu ale selectului. `es-select`
       desenează săgeata din dreapta, iar câmpul nostru se scrie, nu se
       derulează — săgeata acolo doar induce în eroare. Le luăm de pe
       câmpul de localitate, ca să arate identic cu restul formularului. */
    var model = document.querySelector('#es-city');
    camp.className = ((model && model.className) || 'es-input es-form-control') + ' ln-cauta__camp';
    camp.setAttribute('placeholder', select.getAttribute('placeholder') || 'Alege județul');
    camp.setAttribute('autocomplete', 'off');
    camp.setAttribute('autocapitalize', 'words');
    camp.setAttribute('data-clarity-mask', 'true');
    if (select.hasAttribute('required')) {
      camp.required = true;
      select.removeAttribute('required');   /* vezi regula 2 din capul fișierului */
    }
    if (select.value) camp.value = select.options[select.selectedIndex].text.trim();
    camp.setCustomValidity(select.value ? '' : 'Alege județul din listă.');

    var invelis = document.createElement('div');
    invelis.className = 'ln-cauta';
    select.parentNode.insertBefore(invelis, select);
    invelis.appendChild(camp);
    invelis.appendChild(select);
    select.classList.add('ln-cauta__ascuns');

    var cutie = faceCutie(camp);
    urmareste(cutie, camp);

    /* Câmpul nostru e valid DOAR cât timp selectul are o valoare adevărată.
       Fără asta, cineva care scrie „bucuresti" și apasă direct pe Comandă
       trimite o comandă fără județ: câmpul nostru e completat, deci
       browserul zice că formularul e valid, iar selectul e gol. Măsurat pe
       live, exact așa se întâmpla. */
    function potrivesteValiditatea() {
      camp.setCustomValidity(select.value ? '' : 'Alege județul din listă.');
    }

    function alege(nume) {
      camp.value = nume;
      cutie.hidden = true;
      var val = dupaNume[nume];
      if (val && select.value !== val) {
        select.value = val;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      potrivesteValiditatea();
      var oras = document.querySelector('#es-city');
      if (oras) {
        oras.value = '';
        potrivesteOrasul(val);
        incarcaLocalitati(val);
        setTimeout(function () { try { oras.focus(); } catch (e) {} }, 60);
      }
    }

    camp.addEventListener('input', function () {
      deseneaza(cutie, filtreaza(optiuni, camp.value), alege, camp);
      /* Cât timp scrie, selectul nu mai are o valoare valabilă. */
      if (select.value && simplu(camp.value) !== simplu(select.options[select.selectedIndex].text)) {
        select.value = '';
        /* Județul nu mai e ales: nici localitatea nu mai are pe ce să se
           sprijine. Se golește lista și se deblochează scrisul, ca să nu
           rămână câmpul blocat pe sectoare după ce s-a șters Bucureștiul. */
        incarcaLocalitati('');
        potrivesteOrasul('');
      }
      potrivesteValiditatea();
    });
    camp.addEventListener('focus', function () {
      deseneaza(cutie, filtreaza(optiuni, camp.value), alege, camp);
    });
    camp.addEventListener('blur', function () {
      setTimeout(function () { cutie.hidden = true; }, 120);
      /* Dacă a scris ceva care se potrivește exact, îl alegem noi. */
      var gasit = optiuni.filter(function (o) { return simplu(o) === simplu(camp.value); })[0];
      if (gasit) alege(gasit);
      else if (camp.value && !select.value) {
        var primul = filtreaza(optiuni, camp.value)[0];
        if (primul) alege(primul);
      }
      potrivesteValiditatea();
    });
    camp.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        var primul = filtreaza(optiuni, camp.value)[0];
        if (primul && !cutie.hidden) { ev.preventDefault(); alege(primul); }
      } else if (ev.key === 'Escape') {
        cutie.hidden = true;
      }
    });
  }

  /* ---------- localitatea ---------- */

  /* Bucureștiul e singura excepție: acolo „localitatea" e sectorul, sunt
     exact șase și nu există altceva. Câmpul devine doar de ales, nu de
     scris — așa nu mai ajung la curier adrese de tipul „Bucuresti" sau
     „sector3 langa piata". În rest, oriunde altundeva, omul scrie liber:
     satele mici lipsesc din orice bază de date.

     `readOnly`, nu `disabled`: un câmp dezactivat nu se trimite deloc cu
     formularul, iar comanda ar pleca fără localitate. */
  function potrivesteOrasul(valJudet) {
    var oras = document.querySelector('#es-city');
    if (!oras) return;
    var doarSectoare = (valJudet || '').replace(/^RO[_-]?/, '') === 'B';
    oras.readOnly = doarSectoare;
    oras.classList.toggle('ln-cauta__doar-ales', doarSectoare);
    if (doarSectoare) {
      oras.setAttribute('placeholder', 'Alege sectorul');
      oras.setAttribute('inputmode', 'none');
    } else {
      oras.removeAttribute('inputmode');
      if (oras.dataset.lnPh) oras.setAttribute('placeholder', oras.dataset.lnPh);
    }
  }

  function incarcaLocalitati(valJudet) {
    var cod = (valJudet || '').replace(/^RO[_-]?/, '');
    codCurent = cod || null;

    /* Se aruncă imediat, nu când sosește cea nouă. O listă de la alt județ
       e mai rea decât nicio listă: omul alege un sat care nu există acolo. */
    if (!listaLocalitati || listaLocalitati.cod !== cod) listaLocalitati = null;

    if (!cod || !window.LN_LOC_URL) return;
    if (cereriInCurs[cod]) return;
    cereriInCurs[cod] = 1;

    fetch(window.LN_LOC_URL.replace('ln-loc-XX', 'ln-loc-' + cod))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (lista) {
        /* Între timp poate s-a schimbat județul din nou; răspunsul vechi
           nu are voie să suprascrie. */
        if (lista && lista.length && codCurent === cod) {
          listaLocalitati = { cod: cod, nume: lista };
          if (reDeseneazaOrasul) reDeseneazaOrasul();
        }
      })
      .catch(function () {})
      .then(function () { delete cereriInCurs[cod]; });
  }

  function legOrasul(camp) {
    if (camp.dataset.lnGata) return;
    camp.dataset.lnGata = '1';
    camp.setAttribute('autocomplete', 'off');
    camp.dataset.lnPh = camp.getAttribute('placeholder') || '';

    var cutie = faceCutie(camp);
    urmareste(cutie, camp);
    var tocmaiAles = false;

    function alege(nume) {
      camp.value = nume;
      cutie.hidden = true;
      /* Evenimentele de mai jos sunt pentru EasySell, ca să vadă ce a ales
         omul. Dar `input` trece și prin ascultătorul nostru și redeschide
         lista peste câmpul tocmai completat. Steagul îl oprește doar pentru
         evenimentele pe care le trimitem noi. */
      tocmaiAles = true;
      camp.dispatchEvent(new Event('input', { bubbles: true }));
      camp.dispatchEvent(new Event('change', { bubbles: true }));
      tocmaiAles = false;
    }

    function arata() {
      if (tocmaiAles) return;
      if (!listaLocalitati || listaLocalitati.cod !== codCurent) {
        var s = document.querySelector('#es-province');
        if (s && s.value) incarcaLocalitati(s.value);
        cutie.hidden = true;
        return;
      }
      /* Bucureștiul e tratat ca județ, iar „localitatea" lui e sectorul.
         Sunt șase, deci le arătăm pe toate din prima, fără să scrie nimic:
         omul nu trebuie să ghicească ce se caută acolo. În rest, lista
         apare abia după ce începe să scrie — nu aruncăm 400 de sate în
         ochii nimănui. */
      var puține = listaLocalitati.nume.length <= 10;
      if (!camp.value.trim() && !puține) { cutie.hidden = true; return; }
      deseneaza(cutie, filtreaza(listaLocalitati.nume, camp.value), alege, camp);
    }

    /* Când lista sosește după ce omul a atins deja câmpul, o desenăm — dar
       numai dacă el chiar stă acolo, altfel i s-ar deschide singură. */
    reDeseneazaOrasul = function () {
      if (document.activeElement === camp) arata();
    };

    camp.addEventListener('input', arata);
    camp.addEventListener('focus', arata);
    /* Un câmp `readOnly` nu trimite `input`, iar pe telefon atingerea nu-i
       dă întotdeauna focus. Fără asta, la București lista nu s-ar deschide
       niciodată și câmpul ar părea stricat. */
    camp.addEventListener('click', arata);
    camp.addEventListener('blur', function () {
      setTimeout(function () { cutie.hidden = true; }, 120);
    });
    camp.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && !cutie.hidden) {
        var primul = filtreaza(listaLocalitati ? listaLocalitati.nume : [], camp.value)[0];
        if (primul) { ev.preventDefault(); alege(primul); }
      } else if (ev.key === 'Escape') {
        cutie.hidden = true;
      }
    });
  }

  /* ---------- pornire ----------
     Formularul e injectat de aplicația lor, oricând după încărcare, și e
     redesenat când omul schimbă produsul. De aceea ne uităm la tot
     documentul și legăm de fiecare dată când apare un câmp nelegat. */
  function incearca() {
    try {
      var s = document.querySelector('#es-province');
      if (s && s.tagName === 'SELECT') legJudetul(s);
      var c = document.querySelector('#es-city');
      if (c) legOrasul(c);
      if (s && s.value && !listaLocalitati) incarcaLocalitati(s.value);
    } catch (e) { /* orice ar pica, formularul lor rămâne intact */ }
  }

  if (window.MutationObserver) {
    new MutationObserver(incearca).observe(document.documentElement, {
      childList: true, subtree: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', incearca);
  } else {
    incearca();
  }
})();
